<template>
  <div id="app" class="container-fluid">
      <masthead></masthead>
      <div class="bg_image"></div>
      <router-view></router-view>
  </div>
</template>

<script>
import Masthead from './components/Masthead'
import Trailer from './components/Trailer'

export default {
  name: 'app',
  components: {
    Masthead,
    Trailer
  }
}
</script>

<style>
  /**
   * Resets
   */
  

  /**
   * Base Styling
   */
  body {
    background: #e0e0e0;
    font:14px/21px 'Roboto','Lato-Regular', Arial, sans-serif;
    color: #444;
    -webkit-font-smoothing: antialiased; /* Fix for webkit rendering */
    -webkit-text-size-adjust: 100%;
  }
  .hide-phone {visibility: visible;}
  b {
    font-weight:700;
  }

  /**
   * Typography
   */
  h1, h2, h3, h4, h5, h6 {
    color: #181818;
    font-family: "Roboto", Impressum-Lig, "Georgia", "Times New Roman", serif;
    font-weight: 400; 
  }
  h1 a, h2 a, h3 a, h4 a, h5 a, h6 a { 
    font-weight: inherit; 
  }
  h1 { font-size: 46px; line-height: 50px; margin-bottom: 14px;}
  h2 { font-size: 28px; line-height: 34px; margin-bottom: 5px; color: #4c5943;}
  h3 { font-size: 28px; line-height: 34px; margin-bottom: 5px; color: #4c5943;}
  h4 { font-size: 21px; line-height: 30px; margin-bottom: 2px; color: #4c5943;}
  h5 { font-size: 16px; line-height: 24px; font-family: 'Lato-Regular', Arial, sans-serif; color:#4c5943;}
  h6 { font-size: 14px; line-height: 21px;}
  .subheader { color: #777; }

  p { margin: 0 0 20px; }
  p img { margin: 0; }
  p.lead { font-size: 21px; line-height: 27px; color: #777;  }

  em { font-style: italic; }
  strong { font-weight: 700; color: #333; font-family:"Roboto",'Lato-Bold', Arial, sans-serif; }
  small { font-size: 80%; }

  /*  Blockquotes  */
  blockquote, blockquote p { font-size: 17px; line-height: 24px; color: #777; font-style: italic; }
  blockquote { margin: 0 0 20px; padding: 9px 20px 0 19px; border-left: 1px solid #ddd; }
  blockquote cite { display: block; font-size: 12px; color: #555; }
  blockquote cite:before { content: "\2014 \0020"; }
  blockquote cite a, blockquote cite a:visited, blockquote cite a:visited { color: #555; }

  hr { border: solid #ddd; border-width: 1px 0 0; clear: both; margin: 10px 0 30px; height: 0; }

  /**
   * Links
   */
  p a, p a:visited { line-height: inherit; }

  /**
   * Lists
   */
  ul, ol { margin-bottom: 20px; }
  ul { list-style: none outside; }
  ol { list-style: decimal; }
  ol, ul.square, ul.circle, ul.disc { margin-left: 30px; }
  ul.square { list-style: square outside; }
  ul.circle { list-style: circle outside; }
  ul.disc { list-style: disc outside; }
  ul ul, ul ol,
  ol ol, ol ul { margin: 4px 0 5px 30px; font-size: 90%;  }
  ul ul li, ul ol li,
  ol ol li, ol ul li { margin-bottom: 6px; }
  li { line-height: 18px; margin-bottom: 12px; }
  ul.large li { line-height: 21px; }
  li p { line-height: 21px; }

  .container_main {
    width: 100%;
    height: 398px;
    clear: both;
    margin:0;
  }
  
  .csp-title-id{
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 36px;
    line-height: 1.15;
    color: #FCFCFC;
    opacity: 1.00;
    padding-left:20px;
    text-shadow: 0px 0px 4px #000;
    
  }
  
  .csp-title-text{
    font-family: "Roboto";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 1.4;
    color: #FCFCFC;
    opacity: 1.00;
    padding-left:20px;
    text-shadow: 0px 0px 4px #000;
  }
  
  .csp-card{
    margin-top: 3vh;
  }
  

  .csp-card-title{
    font-weight: 500;
    color: rgba(107, 143, 83, 1);
  }
  
  .csp-banner-text{
    text-align: justify;
    font-size:1em;
    font-weight:400; /* normal */
    line-height:1.4em;
    padding-bottom:2vh;
    color: rgba(0, 0, 0, 0.65);
  }
  
  .csp-btn-continue{
    float:right;
    margin-bottom:0em;
    white-space: nowrap;
  }
  
  .csp-btn-right{
    float:right;
    white-space: nowrap;
  }
  
  .csp-btn-text{
    color: white;
    white-space: nowrap;
  }
  
  .btn-disabled{
    background-color: #aaa;
  }
  
  .csp-btn-bottom-pad{
    margin-bottom:1.5em;
  }
  
  .csp-progress-group{
    text-align: center;
    margin: .75em auto;
    
  }
  
  .csp-loading{
    text-align:right;
    margin: .75em auto;
    padding-right:1.5rem;
    
  }
  
  .csp-progress-dot{
    border-radius:50%;
    height:.6em;
    width:.6em;
    background-color: #909090;
    display: inline-block;
    margin-right: .3em;
  }
  
  .csp-no-pad{
    padding:0px;
  }
  
  .csp-no-pad-sides{
    padding-left:0px;
    padding-right:0px;
  }
  
  .csp-no-margin{
    margin:0px;
  }
  
  .csp-no-margin-sides{
    margin-left:0px;
    margin-right:0px;
  }
  
  .csp-text-center{
    text-align:center;
  }
  
  /**
   * Default Background Image
   */
  .bg_image {
    position: fixed;
    left: 0px;
    right:0px;
    top: 0px;
    z-index: -1;
  
    display: block;
    height: 100%;
    width: 100%;

    background-image: url(./assets/images/courtyard_stone_home_gblur_15_cpr.jpg);
    background-repeat: no-repeat;
    background-position-x: calc(50% + 80px);
    background-position-y: 50%;
    background-attachment:fixed; 
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    opacity:.9;
  }
  
  .card{
    background-color:white;
  }
  
  [v-cloak], .hidden {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// App.vue?60d5b027